import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=f213b6f4&"
import script from "./Cases.vue?vue&type=script&lang=js&"
export * from "./Cases.vue?vue&type=script&lang=js&"
import style0 from "./Cases.vue?vue&type=style&index=0&id=f213b6f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports